var React = require('react');

function Icn00Dark (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".dark_00_a,.dark_00_b{fill:none;stroke-miterlimit:10;stroke-width:2px;}.dark_00_a{stroke:#f0a346;}.dark_00_b{stroke:#121c25;opacity:0.5;}")),React.createElement("rect",{"className":"dark_00_a","x":"10.25","y":"10.17","width":"10.76","height":"10.92","transform":"translate(15.63 -6.47) rotate(45)","key":1}),React.createElement("rect",{"className":"dark_00_b","x":"6.59","y":"6.45","width":"18.08","height":"18.36","transform":"translate(15.63 -6.47) rotate(45)","key":2})]);
}

Icn00Dark.defaultProps = {"viewBox":"0 0 31.26 31.26"};

module.exports = Icn00Dark;

Icn00Dark.default = Icn00Dark;
